import {inject, Injectable} from '@angular/core';
import {DocumentData} from "../types/document-modal.types";
import {DocumentModalApiService} from "./document-modal-api.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {fieldsWithStatus} from "../configs/documents-model-config";
import {DocumentUpdateParams} from "../types/document-update.types";


@Injectable({
  providedIn: 'root'
})
export class DocumentModalService {
  private documentModalApiService: DocumentModalApiService = inject(DocumentModalApiService);
  private fb: FormBuilder = inject(FormBuilder);

  public getDocumentsData(documentId: number): Promise<DocumentData> {
    return new Promise((resolve, reject) => {
      this.documentModalApiService.getDocumentModalData(documentId).subscribe({
        next: (documentsData: DocumentData) => resolve(documentsData),
        error: (error) => reject(error)
      });
    });
  }

  public async updateDocumentData(documentUpdateParams: DocumentUpdateParams): Promise<DocumentData> {
    return new Promise((resolve, reject) => {
      this.documentModalApiService.updateDocumentValue(documentUpdateParams).subscribe({
        next: (documentData: DocumentData) => resolve(documentData),
        error: (error) => reject(error)
      });
    });
  }

  public createForm(): FormGroup {
    return this.fb.group({
      bankDetails: this.fb.group({
        completeDate: [null]
      }),
      contract: this.fb.group({
        number: [null],
        date: [null],
        status: [null],
        processedByName: [null],
        signedDocumentLink: [null]
      }),
      erid: this.fb.group({
        link: [null],
        status: [null],
        number: [null]
      }),
      payment: this.fb.group({
        link: [null],
        status: [null],
        date: [null]
      }),
      act: this.fb.group({
        actLink: [null],
        status: [null],
        date: [null],
        receiptLink: [null]
      }),
      edo: this.fb.group({
        status: [null]
      }),
      oneC: this.fb.group({
        status: [null],
        documentDiskLink: [null]
      }),
      documentFiles: this.fb.group({
        actFileId: [null],
        signedActFileId: [null],
        contractFileId: [null],
        signedContractFileId: [null],
        techTaskFileId: [null],
        signedTechTaskFileId: [null],
        receiptFileId: [null]
      })
    });
  }

  public setStatusFields(formData: FormGroup): void {
    fieldsWithStatus.forEach(field => {
      const status = formData?.value[field]?.status;

      if (status && status.currentValue === null) {
        formData.value[field].status = null;
      }
    });
  }
}
